<template>
  <el-dialog
    :title="form.roomUid ? '修改語音房' : '新增語音房'"
    :visible.sync="dialogVisible"
    width="30%"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="廳名稱">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <div class="upload-box">
        <span class="upload-title">廳封面</span>
        <el-upload
          class="avatar-uploader"
          action="https://api.dev.nicee.app/basic/image/upload"
          :show-file-list="false"
          :http-request="uploadCoverImg"
          :before-upload="beforeAvatarUpload"
          accept="image/png,image/jpg,image/jpeg,image/webp"
          v-loading="uploadCoverImgLoading"
        >
          <img v-if="form.coverImgUrl" :src="form.coverImgUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="upload-box">
        <span class="upload-title">廳背景</span>
        <el-upload
          class="avatar-uploader"
          action="https://api.dev.nicee.app/basic/image/upload"
          :show-file-list="false"
          :http-request="uploadBackImg"
          :before-upload="beforeAvatarUpload"
          accept="image/png,image/jpg,image/jpeg,image/webp"
          v-loading="uploadBackImgLoading"
        >
          <img v-if="form.backImgUrl" :src="form.backImgUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <el-form-item label="廳狀態">
        <el-radio v-model="form.recommend" :label="1">顯示</el-radio>
        <el-radio v-model="form.recommend" :label="0">隱藏</el-radio>
      </el-form-item>
      <el-form-item label="廳公告">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 6 }"
          placeholder=""
          v-model="form.desc"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button
        type="primary"
        :disabled="submitDisabled"
        :loading="submitLoading"
        @click="submit()"
        >確定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { uploadImageToS3 } from '@/api';
export default {
  name: 'editVoiceRoom',
  props: {
    voiceRoomDetail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        name: '',
        backImgUrl: '',
        coverImgUrl: '',
        desc: '',
        recommend: '1'
      },
      submitLoading: false,
      uploadBackImgLoading: false,
      uploadCoverImgLoading: false
    };
  },
  watch: {},
  computed: {
    submitDisabled() {
      return !(this.form.name && this.form.backImgUrl && this.form.coverImgUrl);
    }
  },
  methods: {
    submit() {
      if (this.submitLoading) return;
      this.submitLoading = true;
      if (this.form.roomUid) {
        this.editVoiceRoom();
      } else {
        this.createVoiceRoom();
      }
    },
    editVoiceRoom() {
      this.$http
        .post('/voiceRoom/update', {
          ...this.form
        })
        .then(() => {
          this.submitLoading = false;
          this.$message.success('修改成功');
          this.$emit('update-success');
          this.dialogVisible = false;
        })
        .catch(() => {
          this.$message.error('修改失敗');
          this.submitLoading = false;
        });
    },
    createVoiceRoom() {
      this.$http
        .post('/voiceRoom/createOrUpdate', {
          ...this.form,
          gameType: 0,
          seats: 1,
          roomTheme: 1,
          roomType: 1
        })
        .then(() => {
          this.submitLoading = false;
          this.$message.success('新增成功');
          this.$emit('create-success');
          this.dialogVisible = false;
        })
        .catch(() => {
          this.$message.error('新增失敗');
          this.submitLoading = false;
        });
    },
    open() {
      this.form.name = this.voiceRoomDetail.name;
      this.form.backImgUrl = this.voiceRoomDetail.backImgUrl;
      this.form.coverImgUrl = this.voiceRoomDetail.coverImgUrl;
      this.form.desc = this.voiceRoomDetail.desc;
      this.form.recommend = this.voiceRoomDetail.recommend;
      this.form.roomUid = this.voiceRoomDetail.roomUid;
      this.dialogVisible = true;
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === 'image/jpeg' ||
        'image/jpg' ||
        'image/png' ||
        'image/webp';
      const isLt2M = file.size / 1024 / 1024 < 10;

      if (!isJPG) {
        this.$message.error('上傳圖片只能是 JPG/JPEG/PNG/WEBP 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上傳圖片大小不能超過 10MB!');
      }
      return isJPG && isLt2M;
    },
    //上傳背景圖片
    uploadBackImg({ file }) {
      this.uploadBackImgLoading = true;
      const fd = new FormData();
      fd.append('file', file);
      uploadImageToS3(fd)
        .then(({ data }) => {
          this.form.backImgUrl = data;
          this.uploadBackImgLoading = false;
        })
        .catch(() => {
          this.uploadBackImgLoading = false;
        });
    },
    //上傳封面圖片
    uploadCoverImg({ file }) {
      this.uploadCoverImgLoading = true;
      const fd = new FormData();
      fd.append('file', file);
      uploadImageToS3(fd)
        .then(({ data }) => {
          this.form.coverImgUrl = data;
          this.uploadCoverImgLoading = false;
        })
        .catch(() => {
          this.uploadCoverImgLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .el-form-item__label {
  text-align: left;
}
.upload-box {
  display: flex;
  margin-bottom: 22px;
  /deep/ .el-upload {
    width: 100px;
    height: 100px;
    border: 1px solid #ebebeb;
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-icon-plus {
      font-size: 30px;
      color: #ebebeb;
    }
  }
  img {
    width: 100px;
    height: 100px;
    object-fit: cover;
  }
  .upload-title {
    width: 80px;
    padding-right: 12px;
    text-align: left;
    line-height: 40px;
  }
}
</style>
